// extracted by mini-css-extract-plugin
module.exports = {"Certificate":"Certificate_Certificate__2dLkH"};